import styled from '@secretescapes/falcon';

export const StyledInfoBox = styled('div')`
  a {
    color: #0a8ea0;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
